import { RadioMantine, Stack } from 'ui';
import { useForm } from 'ui/Form';

import { useFormListValidator } from '../../../..';
import { ACCOUNT_CODE_FEATURES } from '../../../../utils';
import { AccountCodeFeatures } from './AssignAccountCodes.types';

type Props = {
  count?: number;
  feature: AccountCodeFeatures;
  isRemoving?: boolean;
};

export type HistoricalTransactionFormType = {
  applyTo: 'new' | 'all';
};

const HistoricalTransactionRadio = ({ count, feature, isRemoving = false }: Props) => {
  const form = useForm({
    initialValues: {
      applyTo: feature == ACCOUNT_CODE_FEATURES.QUICK_PAY ? 'new' : 'all',
    },
  });

  useFormListValidator({ form, id: 'edit_historical_transaction' });

  return (
    <RadioMantine.Group
      size="md"
      label={
        isRemoving
          ? 'Please choose from the following removal options'
          : 'Please choose from the following edit options:'
      }
      {...form.getInputProps('applyTo')}
    >
      <Stack gap="md">
        <RadioMantine
          value="new"
          label={
            isRemoving
              ? 'Remove assignment for new transactions only'
              : 'Edit assignment for new transactions only'
          }
        />
        <RadioMantine
          value="all"
          label={
            isRemoving
              ? `Remove assignment for new and ${
                  feature == ACCOUNT_CODE_FEATURES.SHOP_TO_GIVE ? '' : `${count} `
                }historical transactions`
              : `Edit assignment for new and ${
                  feature == ACCOUNT_CODE_FEATURES.SHOP_TO_GIVE ? '' : `${count} `
                }historical transactions`
          }
        />
      </Stack>
    </RadioMantine.Group>
  );
};

export { HistoricalTransactionRadio };
